import styled from 'styled-components';
import { Form, Input } from '@rocketseat/unform';

import px2vw from '../../../../../utils/responsiveness/px2vw';

import {
  branco,
  cinzaKuppi1,
  cinzaKuppi3,
  cinzaKuppi4,
  verdeKuppi1,
} from '../../../../../styles/colors';

export const FormPaymentData = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PaymentInput = styled(Input)`
  padding: 0.5em;
  margin-top: 5px;
  border: 1px solid ${cinzaKuppi4};
  border-radius: 5px;
  font-size: ${px2vw(14)};
  font-family: AvenirNextLTPro;
  font-weight: normal;
  letter-spacing: 0.36px;
  width: 280px;
  height: ${px2vw(35)};

  ::placeholder {
    color: ${cinzaKuppi4} !important;
  }

  :focus {
    border: 1px solid ${cinzaKuppi3} !important;
    box-shadow: none !important;
  }

  ${(props) => `
    width: ${props.width};
    height: ${props.height};
    margin-top: ${props.margtop};
  `};
`;

export const ChoiceButton = styled.div`
  border: 1px solid ${cinzaKuppi3};
  background-color: ${branco};
  width: ${px2vw(12)};
  height: ${px2vw(12)};
`;

export const ChoiceButtonSelected = styled.div`
  position: absolute;
  background-color: ${verdeKuppi1};
  width: ${px2vw(8)};
  height: ${px2vw(8)};
  margin-top: ${px2vw(2)};
  display: none;

  ${(props) =>
    props.isChecked &&
    `
      display: block;
    `};
`;

export const PaymentChoiceImage = styled.img`
  width: ${px2vw(50)};
  height: ${px2vw(35)};
  margin-bottom: ${px2vw(10)};

  ${(props) => `
    width: ${props.width};
    height: ${props.height};
  `};
`;

export const PaymentSecureImage = styled.img`
  width: ${px2vw(90)};
  height: ${px2vw(45)};
`;

export const PaymentMethodText = styled.span`
  font-size: ${px2vw(14)};
  font-family: AvenirNextLTPro;
  font-weight: normal;
  letter-spacing: 0.32px;
  width: 100%;
`;

export const PaymentMethodText2 = styled.div`
  font-size: ${px2vw(12)};
  font-family: AvenirNextLTPro;
  font-weight: normal;
  letter-spacing: 0.32px;
  margin-top: ${px2vw(2)};
  margin-left: ${px2vw(8)};
  margin-right: ${px2vw(20)};
`;

export const PaymentMethodText3 = styled.span`
  display: inline-block;
  font-size: ${px2vw(12)};
  font-family: AvenirNextLTPro;
  font-weight: normal;
  letter-spacing: 0.32px;
  text-align: center;

  .bold {
    font-family: AvenirNextLTPro;
    font-weight: 700;
  }
`;

export const PaymentMethodTextBold = styled.div`
  font-size: ${px2vw(12)};
  font-family: AvenirNextLTPro;
  font-weight: 700;
  letter-spacing: 0.32px;

  ${(props) => `
    margin-top: ${props.margtop};
  `};
`;

export const Separator = styled.div`
  width: ${px2vw(0.8)};
  height: ${px2vw(70)};
  background-color: ${cinzaKuppi4};
  margin-left: ${px2vw(30)};
  margin-right: ${px2vw(30)};
`;

export const RecommendedPaymentChoice = styled.div`
  width: auto;
  height: auto;
  background-color: ${verdeKuppi1};
  margin-top: ${px2vw(5)};
  color: ${branco};
  font-size: ${px2vw(11)};
  font-family: AvenirNextLTPro;
  font-weight: 700;
  letter-spacing: 0.32px;
  border: 1px solid ${verdeKuppi1};
  border-radius: 5px;
  padding: ${px2vw(2)};
  padding-left: ${px2vw(3)};
  padding-right: ${px2vw(3)};
`;

export const PaymentMethodInfoBox = styled.div`
  width: ${(props) => props.width || px2vw(540)};
  height: auto;
  background-color: ${cinzaKuppi1};
  border: 1px solid ${cinzaKuppi1};
  border-radius: 10px;
  font-size: ${(props) => props.fontSize || px2vw(10)};
  font-family: AvenirNextLTPro;
  font-weight: normal;
  letter-spacing: 0.32px;
  padding: ${(props) => props.pad || px2vw(5)};
  padding-left: ${(props) => props.padleft || px2vw(6)};
  padding-right: ${(props) => props.padright || px2vw(6)};
  margin-top: ${px2vw(20)};
  margin-bottom: ${px2vw(20)};
  margin-left: ${(props) => props.margleft || px2vw(40)};
`;
